<div
  [ngClass]="(item.selected ? 'bg-primary/10' : '') + ' flex items-center justify-between p-3 rounded transition hover:bg-primary/5'">
  <div class="flex flex-col text-sm">
    <span class="font-semibold">{{ item.name }}</span>
    <span class="text-xs text-gray-500" *ngIf="item.quantity && item.quantity > 1">x{{ item.quantity }}</span>
  </div>
  <div class="text-right">
    <p *ngIf="item.total_ttc !== 0 && item.free !== 1" class="text-sm font-semibold">
      {{ item.total_ttc | number:'1.2-2' }} €
    </p>
    <p *ngIf="item.free === 1" class="text-sm font-semibold">
      {{ getFreeLabel(item) }}</p>
    <p *ngIf="item.alreadyPaid" class="text-xs text-green-500">
      {{ getPaidLabel(item) }}
    </p>

  </div>
</div>

<!-- 🔁 Récursion : afficher les enfants -->
<div *ngIf="item.children && item.children.length > 0" class="ml-4 border-l border-gray-200 pl-2 leading-none">
  <app-item-line *ngFor="let child of item.children" [item]="child"></app-item-line>
</div>